'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["isInverted", "className"];
/**
 * Logo of the new Maklerportal
 *
 * Renders the Maklerportal Logo
 */
var LogoMaklerportal = react.forwardRef(function (_ref, ref) {
  var isInverted = _ref.isInverted,
    className = _ref.className,
    rest = _objectWithoutProperties__default["default"](_ref, _excluded);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.svg, _extends__default["default"]({
    __css: {
      w: '100%',
      h: '100%'
    },
    role: "img",
    className: utils.cx('chakra-logo-maklerportal', className)
  }, rest, {
    viewBox: "0 0 2874.33 616.39",
    ref: ref
  }), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "a",
    x1: "112.46",
    y1: "309.13",
    x2: "314.5",
    y2: "309.13",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default["default"].createElement("stop", {
    offset: "0",
    stopColor: "#1992f4"
  }), /*#__PURE__*/React__default["default"].createElement("stop", {
    offset: "1",
    stopColor: "#2b8af6"
  })), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "b",
    x1: "413.98",
    y1: "307.63",
    x2: "612.05",
    y2: "307.63",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "c",
    x1: "638.15",
    y1: "306.61",
    x2: "843.47",
    y2: "306.61",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "d",
    x1: "870.44",
    y1: "307.92",
    x2: "1045.59",
    y2: "307.92",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "e",
    x1: "1075.17",
    y1: "307.92",
    x2: "1201.03",
    y2: "307.92",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "f",
    x1: "1236.7",
    y1: "307.92",
    x2: "1366.04",
    y2: "307.92",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "g",
    x1: "1410.41",
    y1: "307.92",
    x2: "1582.09",
    y2: "307.92",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "h",
    x1: "1613.41",
    y1: "307.92",
    x2: "1775.59",
    y2: "307.92",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "i",
    x1: "1802.2",
    y1: "308.32",
    x2: "2010.41",
    y2: "308.32",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "j",
    x1: "2049.27",
    y1: "307.92",
    x2: "2220.95",
    y2: "307.92",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "k",
    x1: "2232.26",
    y1: "307.92",
    x2: "2383.06",
    y2: "307.92",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "l",
    x1: "2378.42",
    y1: "306.61",
    x2: "2583.74",
    y2: "306.61",
    xlinkHref: "#a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "m",
    x1: "2610.13",
    y1: "307.92",
    x2: "2735.99",
    y2: "307.92",
    xlinkHref: "#a"
  })), /*#__PURE__*/React__default["default"].createElement("path", {
    transform: "translate(112.46 203)",
    d: "M187,5.16H15.08A15.09,15.09,0,0,0,0,20.25V192.13a15.08,15.08,0,0,0,15.08,15.08H187a15.09,15.09,0,0,0,15.09-15.08V20.25A15.1,15.1,0,0,0,187,5.16Zm-24.22,161H89.69l-.12-.27c2.54-1.45,5.09-2.89,7.63-4.36a193.58,193.58,0,0,0,21.94-15.43A179.29,179.29,0,0,0,137.69,130c3.24-3.34,6.39-6.78,9.48-10.26.83-.93,1-.73,1.35.25q7,20.73,14.08,41.44c.4,1.18.66,2.41,1.11,3.56S163.71,166.27,162.74,166.17Z",
    fill: isInverted ? '#fff' : 'url(#a)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M275.06,364.33q-7-20.71-14.09-41.44c-.33-1-.52-1.18-1.34-.25-3.1,3.48-6.25,6.92-9.49,10.26a180.23,180.23,0,0,1-18.54,16.15,193.7,193.7,0,0,1-21.95,15.43c-2.53,1.47-5.08,2.91-7.62,4.36l.11.27h73.05c1,.1,1.4-.13,1-1.22S275.46,365.51,275.06,364.33Z",
    fill: isInverted ? 'transparent' : '#fff'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M234.71,268.06c-3.57-5.58-7.42-10.95-12.62-15.17-3.93-3.19-8.28-5-13.42-3.32a23,23,0,0,0-8.76,5.6,66.77,66.77,0,0,0-10.34,13.09c-8,12.68-14.06,26.28-19.28,40.25-4.6,12.33-8.82,24.8-12.95,37.29-2.45,7.41-4.39,15-6.61,22.49-.26.88,0,1,.79,1,1.51,0,3,0,4.54,0,.95,0,1.9,0,2.86,0,1.23,0,2.44.14,3.6-.68,9.17-6.45,18.51-12.67,27.55-19.31A396.21,396.21,0,0,0,227.43,318a245.79,245.79,0,0,0,20.74-22,1.6,1.6,0,0,0,.26-2A224.45,224.45,0,0,0,234.71,268.06Z",
    fill: "#f2686d"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M593.49,205.84h18.56V409.42H559V318.94l-43.21,45.24H510l-42.92-45.24v90.48H414V205.84h19.14L512.58,294Z",
    fill: isInverted ? '#fff' : 'url(#b)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M780.83,383.9h-80L688.9,409.42H638.15v-7.54L729.5,203.81h22.33l91.64,198.07v7.54H792.72Zm-40.31-98L717.9,339.24h45.82Z",
    fill: isInverted ? '#fff' : 'url(#c)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M870.44,409.42v-203h52.78v76.85H927c51.9,0,49.29-38.86,49.29-76.85h53.36c0,41.47,1.16,79.75-39.15,105.56l55.1,89.32v8.12H987.88l-44.65-78.59c-7,1.16-13.34,1.16-20,1.16v77.43Z",
    fill: isInverted ? '#fff' : 'url(#d)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1127.37,362.73H1201v46.69H1075.17v-203h52.2Z",
    fill: isInverted ? '#fff' : 'url(#e)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1363.43,252.82h-75.11v28.71h69v46.11h-69v35.67H1366v46.11H1236.7v-203h126.73Z",
    fill: isInverted ? '#fff' : 'url(#f)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1582.09,401.88v7.54h-58l-34.8-59.74h-27v59.74h-51.91v-203h89c79.75.29,94.25,96.28,42.92,131.08Zm-82.65-149.06c-12.18-.29-24.94,0-37.12,0V303h37.12C1527.57,303,1529,253.11,1499.44,252.82Z",
    fill: isInverted ? '#fff' : 'url(#g)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1613.41,409.42v-203h89.32c97.14.29,97.14,151.09,0,151.09h-37.41v51.91Zm89-156.6c-12.18-.29-25.23,0-37.12,0v58h37.12C1730.86,310.82,1732.6,253.11,1702.44,252.82Z",
    fill: isInverted ? '#fff' : 'url(#h)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1802.2,308.21c0-140.36,208.21-140.36,208.21,0C2010.41,448.86,1802.2,448.86,1802.2,308.21Zm155.14,0c0-73.08-101.79-73.08-101.79,0C1855.55,381.87,1957.34,381.87,1957.34,308.21Z",
    fill: isInverted ? '#fff' : 'url(#i)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2221,401.88v7.54h-58l-34.8-59.74h-27v59.74h-51.91v-203h89c79.75.29,94.25,96.28,42.92,131.08ZM2138.3,252.82c-12.18-.29-24.94,0-37.12,0V303h37.12C2166.43,303,2167.88,253.11,2138.3,252.82Z",
    fill: isInverted ? '#fff' : 'url(#j)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2232.26,252.82v-46.4h150.8v46.4h-49.59v156.6h-51.33V252.82Z",
    fill: isInverted ? '#fff' : 'url(#k)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2521.1,383.9h-80l-11.89,25.52h-50.75v-7.54l91.35-198.07h22.33l91.64,198.07v7.54H2533Zm-40.31-98-22.62,53.36H2504Z",
    fill: isInverted ? '#fff' : 'url(#l)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2662.33,362.73H2736v46.69H2610.13v-203h52.2Z",
    fill: isInverted ? '#fff' : 'url(#m)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M593.49,205.84h18.56V409.42H559V318.94l-43.21,45.24H510l-42.92-45.24v90.48H414V205.84h19.14L512.58,294Z",
    fill: isInverted ? '#fff' : 'url(#b)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M780.83,383.9h-80L688.9,409.42H638.15v-7.54L729.5,203.81h22.33l91.64,198.07v7.54H792.72Zm-40.31-98L717.9,339.24h45.82Z",
    fill: isInverted ? '#fff' : 'url(#c)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M870.44,409.42v-203h52.78v76.85H927c51.9,0,49.29-38.86,49.29-76.85h53.36c0,41.47,1.16,79.75-39.15,105.56l55.1,89.32v8.12H987.88l-44.65-78.59c-7,1.16-13.34,1.16-20,1.16v77.43Z",
    fill: isInverted ? '#fff' : 'url(#d)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1127.37,362.73H1201v46.69H1075.17v-203h52.2Z",
    fill: isInverted ? '#fff' : 'url(#e)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1363.43,252.82h-75.11v28.71h69v46.11h-69v35.67H1366v46.11H1236.7v-203h126.73Z",
    fill: isInverted ? '#fff' : 'url(#f)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1582.09,401.88v7.54h-58l-34.8-59.74h-27v59.74h-51.91v-203h89c79.75.29,94.25,96.28,42.92,131.08Zm-82.65-149.06c-12.18-.29-24.94,0-37.12,0V303h37.12C1527.57,303,1529,253.11,1499.44,252.82Z",
    fill: isInverted ? '#fff' : 'url(#g)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1613.41,409.42v-203h89.32c97.14.29,97.14,151.09,0,151.09h-37.41v51.91Zm89-156.6c-12.18-.29-25.23,0-37.12,0v58h37.12C1730.86,310.82,1732.6,253.11,1702.44,252.82Z",
    fill: isInverted ? '#fff' : 'url(#h)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1802.2,308.21c0-140.36,208.21-140.36,208.21,0C2010.41,448.86,1802.2,448.86,1802.2,308.21Zm155.14,0c0-73.08-101.79-73.08-101.79,0C1855.55,381.87,1957.34,381.87,1957.34,308.21Z",
    fill: isInverted ? '#fff' : 'url(#i)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2221,401.88v7.54h-58l-34.8-59.74h-27v59.74h-51.91v-203h89c79.75.29,94.25,96.28,42.92,131.08ZM2138.3,252.82c-12.18-.29-24.94,0-37.12,0V303h37.12C2166.43,303,2167.88,253.11,2138.3,252.82Z",
    fill: isInverted ? '#fff' : 'url(#j)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2232.26,252.82v-46.4h150.8v46.4h-49.59v156.6h-51.33V252.82Z",
    fill: isInverted ? '#fff' : 'url(#k)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2521.1,383.9h-80l-11.89,25.52h-50.75v-7.54l91.35-198.07h22.33l91.64,198.07v7.54H2533Zm-40.31-98-22.62,53.36H2504Z",
    fill: isInverted ? '#fff' : 'url(#l)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2662.33,362.73H2736v46.69H2610.13v-203h52.2Z",
    fill: isInverted ? '#fff' : 'url(#m)'
  }));
});
LogoMaklerportal.displayName = 'LogoMaklerportal';
exports.LogoMaklerportal = LogoMaklerportal;